/**
 * Created by Eran.Shain on 5/1/2017.
 */
enum frameStates {
    Loading,
    Loaded,
    Error,
    NoData,
}
export default frameStates;
